import React, { Component } from 'react';
import { connect } from 'react-redux';

import * as userActions from '../store/actions/userActions';
import {clearPersonal, getPersonalInfo} from "../store/actions/userActions";

const withUser = WrappedComponent => {
    class withUser extends Component {
        render() {
            return <WrappedComponent {...this.props} />
        }
    }

    const mapStateToProps = state => ({
        authorized: state.user.authorized,
        user: state.user.user,
        isLoadingUser: state.user.isLoadingUser,
        isReferralsLoading: state.user.isReferralsLoading,
        referrals: state.user.referrals,
        personalInfo: state.user.personalInfo,
        isPersonalInfoLoading: state.user.isPersonalInfoLoading,
        isConfirmationProceed: state.user.isConfirmationProceed,
        startTimer: state.user.startTimer,
        confirmLoading: state.user.confirmLoading,
        confirmEmailMessage: state.user.confirmEmailMessage,
        isProceedPersonal: state.user.isProceedPersonal,

    });

    const mapDispatchToProps = (dispatch) => ({
        setAuthData: (wallet) => dispatch(userActions.setAuthData(wallet)),
        deleteAuthData: () => dispatch(userActions.deleteAuthData()),
        getReferrals: () => dispatch(userActions.getReferrals()),
        getPersonalInfo: () => dispatch(userActions.getPersonalInfo()),
        sendConfirmationLink: (id) => dispatch(userActions.sendConfirmationLink(id)),
        userUpdatePersonalInfoAction: (userData, cb, wait) => dispatch(userActions.userUpdatePersonalInfoAction(userData, cb, wait)),
        endTimer: () => dispatch(userActions.endTimer()),
        confirmEmailAction: (data, cb) => dispatch(userActions.confirmEmailAction(data, cb)),
        clearPersonal: (data, cb) => dispatch(userActions.clearPersonal(data, cb)),

        // getUser: () => dispatch(userActions.getUser()),
    });

    return connect(
        mapStateToProps,
        mapDispatchToProps
    )(withUser);
};

export default withUser;
